import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import FeedViewImpl from './feed-view.js';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Vertical CMS event cards feed.
 *
 * @class FeedView
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */

/**
 * `FeedView` prop types.
 *
 * @property {string} [selectedSportId] - Sport id chosen in the feed sport filter (passed from the home page wrapper). When omitted or `all`, every match card and prop carousel card is shown; otherwise only cards for that sport id are rendered.
 * @property {Function} [onSportsLoad] - Called when the feed and prop carousel sport ids change (after feed promotions load). Used to drive the sport filter when wrapped in `SportsFilterContainer`.
 *
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */
const propTypes = {
    selectedSportId: PropTypes.string,
    onSportsLoad: PropTypes.func,
};

const defaultProps = {
    onSportsLoad: noop,
};

export default UIView('FeedView', FeedViewImpl, propTypes, defaultProps);
